import { wa } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const msg =
    "Halo HATTORY KONVEKSI, saya ingin bertanya seputar produk dan pemesanan.";
  return (
    <a
      data-testid="wa-floating-btn"
      href={wa(msg)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Hubungi via WhatsApp"
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-2 rounded-full bg-wa px-5 py-3 font-medium text-white shadow-lift transition-transform duration-300 hover:scale-105 active:scale-95"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      <span className="hidden sm:inline">Chat WhatsApp</span>
    </a>
  );
}
